import { gql } from '@apollo/client'

import { PERSONALIZED_ADDRESS_FRAGMENT } from '../personalizedAddress'

export const SHOP_BILLING_ADDRESS_FRAGMENT = gql`
  fragment ShopBillingAddress on ShopBillingAddress {
    ...PersonalizedAddress
  }
  ${PERSONALIZED_ADDRESS_FRAGMENT}
`
